module.exports = __webpack_public_path__ + "img/free-sample.eb7555fa.jpg";